import { useEffect, useState } from "react";
import firebaseInitialization from "../components/firebase/firebase.init";
import { getAuth, GoogleAuthProvider, onAuthStateChanged, signInWithPopup, signOut } from "firebase/auth";


firebaseInitialization()

const useFirebase = () => {
    const [user, setUser] = useState(null)
    const [isLoading, setIsLoading] = useState(true)

    const provider = new GoogleAuthProvider()
    const auth = getAuth()

    const signInWithGoolge = (navigate) => {
        setIsLoading(true)
        signInWithPopup(auth, provider)
            .then(result => {
                setUser(result.user)
                if (result.user.email === "md.hazratali4510@gmail.com") {
                    navigate('/dashboard')
                }
            })
            .catch(error => {
                console.log(error)
            })
            .finally(() => setIsLoading(false))
    }


    const signOutUser = () => {
        signOut(auth)
            .then(() => {

            })
            .catch(error => {
                console.log(error)
            })
    }

    useEffect(() => {
        const unSubscribe = onAuthStateChanged(auth, user => {
            if (user) {
                setUser(user)
            } else {
                setUser(null)
            }
            setIsLoading(false)
        })
        return () => unSubscribe;
    }, [auth])


    return {
        user,
        signInWithGoolge,
        isLoading,
        signOutUser
    }
}

export default useFirebase;